export default __webpack_public_path__ + "static/media/ac_tc.a62eaa7f.bmp";